import classNames from "classnames";
import React from "react";
import CSSModules from "lib/utils/css-modules";
import { Header, Dimmer, Loader, Button } from "lib/components/vendor";

import styles from "./MainView.less";

@CSSModules(styles)
class MainViewContainer extends React.PureComponent {
  static displayName = "MainView.Container";

  render() {
    const { children, ...rest } = this.props;
    return (
      <div styleName="container" {...rest}>
        {children}
      </div>
    );
  }
}

@CSSModules(styles)
class MainViewContent extends React.PureComponent {
  static displayName = "MainView.Content";

  render() {
    const { padded = true, grayBackground = false, hasSubBar = false, className, ...rest } = this.props;
    return (
      <div
        className={classNames(styles["content"], className, {
          [styles["padded"]]: padded,
          [styles["grayBackground"]]: grayBackground,
          [styles["hasSubBar"]]: hasSubBar,
        })}
        {...rest}
      >
        {this.props.children}
      </div>
    );
  }
}

@CSSModules(styles)
class MainViewDimmer extends React.PureComponent {
  static displayName = "MainView.Dimmer";

  render() {
    const {
      loading,
      failed,
      errorTitle = I18n.t("papp.components.MainView.default_error_title"),
      errorId,
      errorDate,
      retry,
      placeholderIcon,
      placeholderTitle,
      placeholderMessage,
      children,
    } = this.props;
    return (
      <Dimmer inverted active={!!(loading || failed || placeholderTitle || children)}>
        {loading && <Loader>{I18n.t("papp.components.MainView.loading")}</Loader>}

        {failed && (
          <MainViewDimmerContent color="red" icon="error" title={errorTitle}>
            <p>
              {I18n.tt("papp.components.MainView.error_description", {
                email: <a href={`mailto:${I18n.t("papp.common.st_email")}`}>{I18n.t("papp.common.st_email")}</a>,
              })}
            </p>
            {errorId && (
              <p>
                {I18n.t("papp.components.MainView.error_id")}: {errorId}
              </p>
            )}
            {errorDate && (
              <p>
                {I18n.t("papp.components.MainView.error_date")}: {errorDate}
              </p>
            )}
            {retry && (
              <Button as="a" primary onClick={() => retry()}>
                {I18n.t("papp.components.MainView.retry")}
              </Button>
            )}
          </MainViewDimmerContent>
        )}

        {placeholderTitle && (
          <MainViewDimmerContent icon={placeholderIcon} title={placeholderTitle}>
            {placeholderMessage}
          </MainViewDimmerContent>
        )}

        {children}
      </Dimmer>
    );
  }
}

@CSSModules(styles)
class MainViewDimmerContent extends React.PureComponent {
  static displayName = "MainView.DimmerContent";

  render() {
    const { icon, title, children, color } = this.props;
    return (
      <div styleName="dimmer-content">
        <div styleName="dimmer-content-inner">
          <Header as="h2" icon={!!icon} color={color}>
            {icon && <i className="icon material-icons">{icon}</i>}
            {title}
            <div styleName="dimmer-description">
              <Header.Subheader>{children}</Header.Subheader>
            </div>
          </Header>
        </div>
      </div>
    );
  }
}

export default {
  Container: MainViewContainer,
  Content: MainViewContent,
  Dimmer: MainViewDimmer,
  DimmerContent: MainViewDimmerContent,
};



// WEBPACK FOOTER //
// ./src/lib/components/MainView.jsx